import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-auto",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/avatars/avatar.png"
  })
], -1)
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = { class: "fw-bold text-muted text-hover-primary fs-7" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_9 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.familia?.nombre), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.familia?.email), 1)
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.$t("toolbarUserMenuSignOut")), 1)
    ])
  ]))
}